// eslint-disable-next-line no-unused-vars
import { INNER_ROOT, USER_ROOT, transmission, WEB_METHODS } from '../../network/index'

const ROOT = '/square'

const state = {}

const mutations = {}

/**
 * Actions Naming Rule
 * 기본문법 : CamelCase
 * 작문 : { 메소드 }{ 명칭 }{ 결과타입 }
 *
 * 메소드 예 *
 *  get, post, put, delete 등
 * 명칭 예 *
 *  상담사 : counselor 등
 * 결과 타입 예 *
 *  목록 : List
 *  단건결과 : 없음 등
 */
const actions = {
  /**
   * 사용자 > 광장 전체 조회 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getSquareList ({commit}, payload) {
    // return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/squares`, payload)
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/posts`, payload)
  },

  /**
   * 사용자 > 광장 내가쓴글 조회 API
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getSquareMyList ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/my-posts`, payload)
  },

  /**
   * 사용자 > 광장 게시물 단건 조회 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getSquareOne ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/squares/{squareNo}`, payload)
  },
  /**
   * 사용자 > 광장게시글 등록 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async setSquarePostRegist ({commit}, payload) {
    return transmission(true, WEB_METHODS.POST, `${USER_ROOT + ROOT}/squares`, payload)
  },
  /**
   * 사용자 > 광장게시글 수정 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async setSquarePostModify ({commit}, payload) {
    return transmission(true, WEB_METHODS.PUT, `${USER_ROOT + ROOT}/squares/{squareNo}`, payload)
  },
  /**
   * 사용자 > 광장게시글 삭제 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async setSquarePostDelete ({commit}, payload) {
    return transmission(true, WEB_METHODS.DELETE, `${USER_ROOT + ROOT}/squares/{squareNo}`, payload)
  },

  /**
   * 사용자 > 광장 게시글 댓글 조회 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getSquareCmntList ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/square-cmnts/{squareNo}`, payload)
  },


  /**
   * 사용자 > 광장 게시글 댓글 등록 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async setSquareCmntRegist ({commit}, payload) {
    return transmission(true, WEB_METHODS.POST, `${USER_ROOT + ROOT}/square-cmnts/squares`, payload)
  },

  /**
   * 사용자 > 광장 게시글 댓글 수정 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async setModifyCmnt ({commit}, payload) {
    return transmission(true, WEB_METHODS.PUT, `${USER_ROOT + ROOT}/square-cmnts/{cmntNo}`, payload)
  },

   /**
   * 사용자 > 광장 게시글 댓글 삭제 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async setDeleteCmnt ({commit}, payload) {
    return transmission(true, WEB_METHODS.DELETE, `${USER_ROOT + ROOT}/square-cmnts/{cmntNo}`, payload)
  },


  /**
   * 사용자 > 광장 게시글 칭찬해요 수 조회 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getByPraises ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/square-praises`, payload)
  },


  /**
   * 사용자 > 광장 게시글 칭찬해요 등록 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async setByPraisesRegist ({commit}, payload) {
    return transmission(true, WEB_METHODS.POST, `${USER_ROOT + ROOT}/square-praises`, payload)
  },

   /**
   * 사용자 > 광장 게시글 칭찬해요 삭제 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async setDeleteByPraises ({commit}, payload) {
    return transmission(true, WEB_METHODS.DELETE, `${USER_ROOT + ROOT}/square-praises`, payload)
  },

  /**
   * 사용자 > 광장 게시글 신고하기 등록 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async setRptReason ({commit}, payload) {
    return transmission(true, WEB_METHODS.POST, `${USER_ROOT + ROOT}/square-rtp`, payload)
  },

  /**
   * 사용자 > 광장 게시물 등록 가능여부 조회 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getSquareRegistPossible ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/square-regist-is/{gb}`, payload)
  },
}

export default { state, mutations, actions }
